import React, { memo } from 'react';
import cls from './DaysModeCharter.module.css';
import classNames from 'classnames';
import { DaysModePosition } from '../DaysModePosition/DaysModePosition';
import { useSelector } from 'react-redux';
import { positionSelector } from '../../../../../../../store/reducers/positionSlice/positionSlice';
import { DayItemCharter } from './DayItemCharter';
import moment from 'moment/moment';

export const DaysModeCharter = memo(({ charter }) => {
    const { days, opensCharters, settings } = useSelector((state) => state.gantReducer);

    const currentMonths = +moment(charter?.planned.start_date).locale('ru').format('MM');
    const currentDay = +moment(charter?.planned.start_date).locale('ru').format('DD');

    const positions = useSelector(positionSelector.selectEntities);
    const isLabor = charter?.children.some((guid) => positions[guid].type === 'labor');
    const isShowPosition = isLabor || settings.isShowMHD;
    if (!charter || !isShowPosition) {
        return null;
    }

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!charter.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModeCharter)}>
            <div className={classNames(cls.days)}>
                {days.map((month, index) => (
                    <DayItemCharter
                        month={month}
                        charter={charter}
                        isPlanFact={isPlanFact}
                        currentDay={currentDay}
                        currentMonths={currentMonths}
                        key={index}
                    />
                ))}
            </div>
            {opensCharters[charter.guid] && (
                <>
                    {charter.children.map((positionGuid) => (
                        <DaysModePosition
                            key={positionGuid + Date.now()}
                            position={positions[positionGuid]}
                        />
                    ))}
                </>
            )}
        </div>
    );
});
